import type { SubmissionDocRequirement } from "../data/laCountySubmissionCatalog";

export interface PackageFileRef {
  itemId: string;
  fileName: string;
  extension: string;
  folderPath?: string;
}

export interface DocMatchResult {
  requirement: SubmissionDocRequirement;
  status: "present" | "missing";
  matchedFiles: PackageFileRef[];
}

function normalizeName(name: string): string {
  return name.toLowerCase().replace(/[_\-.]+/g, " ");
}

export function matchRequirementsToPackage(
  requirements: SubmissionDocRequirement[],
  files: PackageFileRef[]
): DocMatchResult[] {
  const pdfs = files.filter(f => {
    const ext = f.extension.toLowerCase();
    return (
      ext === ".pdf" ||
      ext === "pdf" ||
      f.fileName.toLowerCase().endsWith(".pdf")
    );
  });

  return requirements.map(requirement => {
    const matchedFiles = pdfs.filter(f => {
      const hay = normalizeName(f.fileName);
      return requirement.matchKeywords.some(kw =>
        hay.includes(kw.toLowerCase())
      );
    });
    return {
      requirement,
      status: matchedFiles.length > 0 ? "present" : "missing",
      matchedFiles,
    };
  });
}

export function requiredDocSummary(results: DocMatchResult[]): {
  present: number;
  required: number;
  missingRequired: number;
} {
  const requiredRows = results.filter(r => r.requirement.required);
  const present = requiredRows.filter(r => r.status === "present").length;
  const missingRequired = requiredRows.filter(
    r => r.status === "missing"
  ).length;
  return { present, required: requiredRows.length, missingRequired };
}
